import api from "./api";

export const getApps = async (): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/apps`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Apps");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getTenantApps = async (): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/apps/tenant-apps`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Apps");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getClientApps = async (): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/client/apps`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Apps");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};